import { V3Record } from 'data/helpers/V3Record.js'

export const CollectionFollower = V3Record('collectionFollower', {
  collectionId: null, // integer
  userId: null // integer
})
